var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#like_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.648 1.028a.75.75 0 0 1 .685-.445 2.75 2.75 0 0 1 2.75 2.75V5.25h3.02a2.083 2.083 0 0 1 2.078 2.396l-.92 6a2.085 2.085 0 0 1-2.079 1.77H2.666a2.083 2.083 0 0 1-2.083-2.083V8.666a2.083 2.083 0 0 1 2.083-2.083H4.18l2.469-5.555ZM3.916 8.083h-1.25a.583.583 0 0 0-.583.583v4.667a.583.583 0 0 0 .583.583h1.25V8.083Zm1.5 5.833h6.779a.583.583 0 0 0 .583-.495l.92-6a.584.584 0 0 0-.583-.671H9.333a.75.75 0 0 1-.75-.75V3.333a1.25 1.25 0 0 0-.8-1.166L5.416 7.492v6.424Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "like_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLike;